import _ from 'lodash';
import { createSelector } from 'reselect';

export const subscriptionTypesSelector = state => _.get(state, 'subscriptions.subscriptions');

export const activeSubscriptionsSelector = createSelector(
    subscriptionTypesSelector,
    subscriptions => subscriptions.filter(s => s.isActive)
);
